// extracted by mini-css-extract-plugin
export var emptyState = "_57-d";
export var statCard = "_57-c";
export var table = "_57-0";
export var tableCell = "_57-4";
export var tableCellClickable = "_57-5 _57-4";
export var tableCellDefault = "_57-6 _57-4";
export var tableCellEmpty = "_57-8";
export var tableCellWithValue = "_57-7";
export var tableContainer = "_57-e";
export var tableHeaderWeight = "_57-1";
export var tableHeaderZone = "_57-2";
export var tableRowHeader = "_57-3";
export var viewModeButton = "_57-9";
export var viewModeButtonActive = "_57-a _57-9";
export var viewModeButtonInactive = "_57-b _57-9";